// Open external Links in new Window
$(document).ready(function() {
    $("a[href^=http]:not(.samewindow)").each(function() {
        if (this.href.indexOf(location.hostname) == -1) {
            $(this).attr({ target: "_blank" });
            $(this).attr({ rel: "noopener" });
            $(this).addClass("external");
        }
    });
    $('a[href$=".pdf"]').attr("target", "_blank");
    $('a[href*="mailto:"]').attr('target', '_blank');
});